import { useQuery } from '@tanstack/react-query';

import { supabase } from '@/lib/supabase';
import { useAuth } from '@/contexts/AuthContext';

export interface MySubmission {
	Id: string;
	CompetitionId: string;
	EntityType: string;
	Title: string;
	Status: 'submitted' | 'withdrawn' | 'judged';
	SubmittedAt: string;
	WithdrawnAt: string | null;
}

export function useMySubmissions(competitionId?: string) {
	const { user } = useAuth();
	return useQuery({
		queryKey: ['my-submissions', user?.id, competitionId ?? 'all'],
		enabled: Boolean(user),
		queryFn: async (): Promise<MySubmission[]> => {
			let q = supabase
				.from('Submissions')
				.select('Id, CompetitionId, EntityType, Title, Status, SubmittedAt, WithdrawnAt')
				.eq('SubmitterUserId', user!.id)
				.order('SubmittedAt', { ascending: false });
			if (competitionId) q = q.eq('CompetitionId', competitionId);
			const { data, error } = await q;
			if (error) throw error;
			return (data as MySubmission[] | null) ?? [];
		},
	});
}
